"use strict";
/**
 * Copyright 2014-present Palantir Technologies
 * @license MIT
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Null = void 0;
var coerceD3_1 = require("../utils/coerceD3");
/**
 * An animator implementation with no animation. The attributes are
 * immediately set on the selection.
 */
var Null = /** @class */ (function () {
    function Null() {
    }
    Null.prototype.totalTime = function (selection) {
        return 0;
    };
    Null.prototype.animate = function (selection, attrToAppliedProjector) {
        selection = (0, coerceD3_1.coerceExternalD3)(selection);
        return selection.attrs(attrToAppliedProjector);
    };
    return Null;
}());
exports.Null = Null;



//////////////////
// WEBPACK FOOTER
// ./src/animators/nullAnimator.ts
// module id = 86
// module chunks = 0